export default __webpack_public_path__ + "static/media/profileAvatar.1c26b816.webp";